const documentsPage = {
  searchDocuments: "Поиск документов...",
  refresh: "Обновить",
  newDocument: "Новый документ",
  noDocuments: "Нет документов",
  total: "Всего",
  currentlyViewing: "Сейчас просматривают",
  signed: "подписали",
  expired: "Истёк",
  now: "сейчас",
  minutesAgo: "{n} мин назад",
  hoursAgo: "{n} ч назад",
  daysAgo: "{n} дн назад",
  draft: "Черновик",
  sent: "Отправлено",
  viewed: "Просмотрено",
  partiallySigned: "Частично",
  signedStatus: "Подписано",
  archived: "Архив",
  analytics: "Аналитика",
  completionRate: "Завершённость",
  completed: "завершено",
  pending: "в ожидании",
  signerProgress: "Прогресс подписантов",
  signersSigned: "подписали",
  avgSignTime: "Среднее время подписи",
  documentsAnalyzed: "документов",
  expiringSoon: "Скоро истекает",
  within7Days: "в течение 7 дней",
  needsAttention: "требует внимания",
} as const;
export default documentsPage;
